import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/tax-binders/$binderId/communications')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/tax-binders/$binderId',
      params: { binderId: params.binderId },
      search: { tab: 'messages' },
      replace: true,
    });
  },
  component: () => null,
});
